<template>
  <div class="wrapper">
    <c-switcher v-model="localValue" :label="field.name" />
  </div>
</template>

<script>
import CSwitcher from "@/components/controls/switcher";

export default {
  components: { CSwitcher },
  props: ["field", "value", "editable"],
  data() {
    return {
      inited: false,
      localValue: false,
    };
  },

  watch: {
    localValue(v) {
      if (this.value === v) return;
      this.$emit("input", { value: v });
      
      if (this.inited) this.$emit("change");
    },
    value(v) {
      this.setData(v);
    },
  },

  created() {
    if (this.value) this.setData(this.value);
  },

  methods: {
    setData(value) {
      if (!value) return;
      this.inited = false;
      this.localValue = !!value.value;
      this.$nextTick(() => {
        this.inited = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  //padding-top: 10px;
}
</style>
